import Cookies from "js-cookie";
const AuthTokenKey = "token";

export const setCookie = Cookies.set;
export const removeCookie = Cookies.remove;
export function getCookie(key, defaultValue) {
  return Cookies.get(key) || defaultValue;
}

export function getToken() {
  const token = window.localStorage.getItem(AuthTokenKey) || "";
  console.log("token in localStorage", token);
  return getCookie(AuthTokenKey, token);
}

export function setToken(authToken) {
  window.localStorage.setItem(AuthTokenKey, authToken);
  return setCookie(AuthTokenKey, authToken, {
    expires: 365, // day(s)
    sameSite: "lax",
    secure: process.env.NODE_ENV === "production",
  });
}

export function removeToken() {
  window.localStorage.removeItem(AuthTokenKey);
  return removeCookie(AuthTokenKey);
}
